// Single source of truth for the recipient count we DISPLAY for an email
// campaign.
//
// `recipients_count` is a denormalized column crm-api recomputes when
// `target_selection` is saved. It can lag the real selection — e.g. a campaign
// saved before the count sync ran shows "0 recipients" in the list even though
// the editor and the details modal clearly show recipients (and Send Now, which
// reads `target_selection` directly, would still send). So when the stored
// count is 0, fall back to the live `target_selection` — the same source of
// truth the editor and Send Now use — so the list never misleadingly reads "0"
// for a campaign that has recipients. (Group members can't be expanded
// client-side; once the campaign is re-saved crm-api fills the real count.)

export interface RecipientCountCampaign {
  recipients_count?: number | null
  target_selection?: { recipients?: unknown[] | null } | null
}

/** Best-known recipient count for display (never wrongly 0 when individuals are selected). */
export function recipientCount(campaign: RecipientCountCampaign): number {
  const stored = campaign.recipients_count || 0
  if (stored > 0) return stored
  return campaign.target_selection?.recipients?.length || 0
}
